export default __webpack_public_path__ + "static/media/menuL_on_icon_07.5486b551.png";